import React from 'react'
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import PropTypes from 'prop-types'

import OrderAPI from '../../../../../../api/orbitV1/OrderAPI'

/**
 * @param {Object} props
 * @param {Object} props.order
 * @param {boolean} props.isOpen
 * @param {() => void} props.onClose
 * @param {boolean} props.deliveryOkay
 * @param {*} props.updateStateReqBody
 */
function DeliveryLoadingDialog(props) {
  const { deliveryOkay, setDeliveryOkay } = props
  let order = props.order

  const { data: getOrderStatus, error } = useQuery(
    'orderConfirmation',
    async () => {
      return OrderAPI.getOrderStatus(order.orderNo)
    },
    { refetchInterval: 5000 }
  )

  if (
    !error &&
    getOrderStatus &&
    getOrderStatus.data.status !== order.status &&
    getOrderStatus.data.status === 'DELIVERY_IN_PROGRESS' &&
    order.orderNo === getOrderStatus.data.orderNo
  ) {
    if (!deliveryOkay) {
      setDeliveryOkay(true)
    }
    order = getOrderStatus.data
  }

  return (
    <Dialog open={props.isOpen}>
      <DialogTitle>
        <strong>Finding you a driver...</strong>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center',
            marginBottom: 8
          }}
        >
          {order.status === 'SCHEDULED_FOR_DELIVERY' ? (
            <Typography>
              Allocating a driver for your order, please give it some time
              while.
            </Typography>
          ) : (
            <>
              <Typography>
                Driver found and is heading to you to pickup your order.
              </Typography>
              <Typography>
                Head to the delivery tab for this order to view more
                information.
              </Typography>
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions
        display='flex'
        justifyContent='center'
        sx={{ textAlign: 'center', marginBottom: '8px' }}
      >
        {deliveryOkay ? (
          <>
            <Button variant='filled' size='small' onClick={props.onClose}>
              Okay
            </Button>
          </>
        ) : (
          <CircularProgress />
        )}
      </DialogActions>
    </Dialog>
  )
}

DeliveryLoadingDialog.propTypes = {
  isOpen: PropTypes.bool,
  order: PropTypes.object,
  onClose: PropTypes.func,
  deliveryOkay: PropTypes.bool,
  setDeliveryOkay: PropTypes.func
}

export default DeliveryLoadingDialog
